import { render, staticRenderFns } from "./softwareModal.vue?vue&type=template&id=34e2b232&scoped=true"
import script from "./softwareModal.vue?vue&type=script&lang=js"
export * from "./softwareModal.vue?vue&type=script&lang=js"
import style0 from "./softwareModal.vue?vue&type=style&index=0&id=34e2b232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2b232",
  null
  
)

export default component.exports